// extracted by mini-css-extract-plugin
export var contrastLow = "_3q-1";
export var externalLink = "_3q-2";
export var externalLinkIcon = "_3q-3";
export var link = "_3q-0";
export var linkLabel = "_3q-4";